import React, { useEffect, useState } from 'react'
import {Container,Row,Col,Button,Form} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from "../../context/auth/useAuth"
import { Link, useNavigate } from 'react-router-dom';
import Version from '../../version';


const clientCredentials = {};

export default function Login() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [islogging, setIslogging] = useState(false)
    const [isCorrect, setIsCorrect] = useState(true)
    const {loginClient,client} = useAuth();
    
    const [showPasswordOne, setShowPasswordOne] = useState(false);

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne);
    };

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        loginClient(clientCredentials).then(() => {
            setIsCorrect(false)
        })
        setIslogging(false)
    }
    useEffect(() => {
        if(client?.rol === 'Client'){
            navigate("/client/dashboard")
        }
        if(client?.rol === 'Kitchen'){
            navigate("/kitchen/dashboard")
        }
        if(client?.rol === 'Admin'){
            navigate("/admin/dashboard")
        }
    },[client,navigate])


    return (
        <Container>
            <Row>
                <Col className="d-flex justify-content-center">
                    <figure className='avatar'>
                        <img src="/images/logotipo.png" style={{width:'150px'}} alt="Logotipo" />
                    </figure>
                </Col>
            </Row>
            <Row>
                <Col className="d-flex justify-content-center text-center">
                    <Form className="p-4 formulario" onSubmit={ handleSubmit}>
                        <Row className="my-3">
                            <h2 className="sd-label text-start">{t('signin.email')}</h2>
                            {isCorrect
                                ?
                                    <Form.Control placeholder={t('signin.emailplace')} name="login_email" className="sd-input" type="text" autoComplete="off" onChange={ (e) => clientCredentials.email = e.target.value} />
                                :
                                    <Form.Control placeholder={t('signin.emailplace')} name="login_email" className="sd-input sd-input-wrong" type="text" autoComplete="off" onChange={ (e) => clientCredentials.email = e.target.value} />
                            }
                        </Row>
                        <Row className="text-center mt-3">
                            <h2 className="sd-label text-start">{t('signin.password')}</h2>
                        </Row>
                        <Row className="text-center mb-3 row-eye">
                            {isCorrect
                                ?
                                    <>
                                        <Form.Control placeholder={t('signin.passwordplace')}  name="login_password" className="sd-input" type={showPasswordOne ? 'text' : 'password'} autoComplete="off" onChange={ (e) => clientCredentials.password = e.target.value} />
                                        <img className="sd-imageneye" src={showPasswordOne ? "../images/eyeclose.svg" : "../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityOne}></img>
                                    </>
                                :
                                    <>
                                        <Form.Control placeholder={t('signin.passwordplace')}  name="login_password" className="sd-input sd-input-wrong" type={showPasswordOne ? 'text' : 'password'} autoComplete="off" onChange={ (e) => clientCredentials.password = e.target.value} />
                                        <img className="sd-imageneye" src={showPasswordOne ? "../images/eyeclose.svg" : "../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityOne}></img>
                                    </>
                            }
                        </Row>
                        <Row className='mb-5'>
                            <Col className="text-end">
                                <Link to="/forgotpassword" className="sd-forgot">{t('signin.forgotpassword')}</Link>
                            </Col>
                        </Row>
                        {!isCorrect
                            ?
                                <>
                                    <span>{t('signin.loginwrong')}</span>
                                </>
                            :
                                <></>
                        }
                        <Row className="text-center my-3">
                            <Col>
                                <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                                {islogging
                                    ?
                                        <>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </>
                                    :
                                        <>{t('signin.login')}</>
                                }
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            <Row>
                <Col className="justify-content-center text-center">
                    <div className='sd-label-small'>{t('signin.createaccount')}</div>
                    <div className='d-flex justify-content-center text-center mt-2'>
                        <Link to="/registerclient" className='btn btn-register'><u>
                            {t('signin.register')}</u>
                        </Link>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className='text-center mt-2'>
                    <Version />
                </Col>
            </Row>
        </Container>
    )
}
